import Vue from "vue";
import App from "./App.vue";
import router from "./router";
// axios
import "@/assets/js/axios/request";
// 样式格式化
import "../public/css/default.css";
// swiper CSS
import "swiper/css/swiper.min.css";
// 引入animate
import "animate.css";
// vue-animate-onScroll;
import VueAnimateOnScroll from "vue-animate-onscroll";
Vue.use(VueAnimateOnScroll);
// WOW
import { WOW } from "wowjs";
Vue.prototype.$wow = new WOW({
    mobile: false,
});
// 全局混入公共方法
import defaultOption from "@/assets/mixin/defaultOption/defaultOption";
Vue.mixin(defaultOption);

Vue.config.productionTip = false;

new Vue({
    router,
    render: h => h(App),
}).$mount("#app");
